var render, staticRenderFns
import script from "./PdpContainer.vue?vue&type=script&lang=js&"
export * from "./PdpContainer.vue?vue&type=script&lang=js&"
import style0 from "./PdpContainer.vue?vue&type=style&index=0&id=73ff3524&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff3524",
  null
  
)

export default component.exports